exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedor-grid{\r\n    margin-top: 1rem;\r\n    margin-left: 1rem;\r\n    margin-right:1rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TPL ILG/3PL_ILG/src/app/components/documento-entrada-list/documento-entrada-list.component.css
// module id = ../../../../../src/app/components/documento-entrada-list/documento-entrada-list.component.css
// module chunks = main